import Common from '../../../Common';
import Item from './ivr/Item';

const IVR = class extends Common {
	item: InstanceType<typeof Item>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.item = new Item(headers);
	}

	browse = (userId: id) => this.get(`/user/${userId}/profile/ivr`)
}

export default IVR;
